"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (input) {
    var output;
    var isCeph = input.match(/^cph_([\w-]+)/);
    if (isCeph) {
        output = "".concat(isCeph[1], ".wpcdn.pl");
    }
    return output;
});
